import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import HeaderProjectSelect from './HeaderProjectSelect';
import Profile from './Profile';
import MobileSection from './MobileSection';
import CounterNo from './CounterNo';
import DepartmentSelect from './DepartmentSelect';
import HeaderPageTitle from './HeaderPageTitle';
import useHeaderVisibility from './HeaderVisibility';

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { showDepartmentSelect, showProjectSelect, showCounterNo } = useHeaderVisibility();

  return (
    <>
      {!downLG && showProjectSelect && <HeaderProjectSelect />}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      <HeaderPageTitle />
      <Box sx={{ flexGrow: 1 }} />
      {!downLG && showDepartmentSelect && <DepartmentSelect />}
      {!downLG && showCounterNo && <CounterNo />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
